const projectSecImages2ColumnsEl = document.querySelector(
  '.project-sec__images.with-2-columns'
);
if (projectSecImages2ColumnsEl) {
  const imagesArr = projectSecImages2ColumnsEl.querySelectorAll(
    '.project-sec__image:not(.col-span-full)'
  );

  if (imagesArr.length < 2) {
    imagesArr.forEach((image) => {
      image.classList.add('col-span-full');
    });
  }
}
